/* eslint-disable global-require */
module.exports = [...require('./Footer/i18n'), 'components.lotslists.pdf.m1', 'components.lotslists.pdf.m2', 'components.lotslists.pdf.m3'];
